const ClientHyfye = () => {
    return (
  <section className="client_logo small_pb">
    <div className="container">
      <div className="row">
        <div className="col-md-12">
  <div className="title_dark title_border text-center">
    <h4 className="animation" data-animation="fadeInUp" data-animation-delay="0.1s">Our Collaborators</h4>
    <p className="animation" data-animation="fadeInUp" data-animation-delay="0.1s">
      Hyfye is building a global <strong>Hybrid Finance (HyFi)</strong> ecosystem powered by micro-apps and community-driven rewards.  
      We’ve partnered with trusted platforms like <strong>PinkSale</strong> and integrated with wallets such as <strong>MetaMask</strong> and <strong>Trust Wallet</strong> to ensure seamless user access.  
      <br /><br />
      As we enter Phase 2, we’re inviting developers, creators, brands, and Web3 communities to build <strong>Hyfye Minis</strong>—decentralized apps that reward everyday actions with HYE tokens.  
      Join us in shaping the future of decentralized gratitude and participation.
    </p>
  </div>
</div>

      </div>
  
      <div className="row align-items-center justify-content-center mt-4">
        <div className="col-md-4 col-sm-6 text-center mb-4 animation" data-animation="fadeInUp" data-animation-delay="0.1s">
          <img src="https://pub-ba546ddaa1784315aecd8b5bd97af3a2.r2.dev/images/sponsors/pinksale.png" loading="lazy" alt="PinkSale" style={{width: "150px"}} />
          <h6 className="mt-3">PinkSale</h6>
        </div>
        <div className="col-md-4 col-sm-6 text-center mb-4 animation" data-animation="fadeInUp" data-animation-delay="0.1s">
          <img src="https://pub-ba546ddaa1784315aecd8b5bd97af3a2.r2.dev/images/sponsors/meta.png" loading="lazy" alt="MetaMask" style={{width: "150px"}} />
          <h6 className="mt-3">MetaMask</h6>
        </div>
      </div>
  
      <div className="row justify-content-center mt-5">
        <div className="col-md-8 text-center">
          <p className="animation" data-animation="fadeInUp" data-animation-delay="0.1s">
            Interested in partnering with Hyfye?  
            <br />  
            <a href="#contact" className="btn btn-default mt-3">Let's Connect</a>
          </p>
        </div>
      </div>
    </div>
  </section>
    )
  }
  
  export default ClientHyfye;
  